import { Chip } from '@mui/material';
import { formatInTimeZone } from 'date-fns-tz';
import { FunctionField } from 'react-admin';
import { timeZone } from '../../../../utils/constants';

export default function ShiftsColumn() {
  const formatShiftTime = shift =>
    `${formatInTimeZone(
      shift.start,
      timeZone,
      'E, d. MMM, HH:mm',
    )} - ${formatInTimeZone(shift.end, timeZone, 'HH:mm')}`;
  return (
    <FunctionField
      render={record => {
        const { shifts } = record?.details || {};
        if (shifts?.length) {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: '10px',
              }}
            >
              {shifts.map((shift, index) => (
                <Chip
                  key={`${shift.label}-${index}`}
                  color="default"
                  label={formatShiftTime(shift)}
                />
              ))}
            </div>
          );
        }
      }}
    />
  );
}
